import React,{useState,useEffect, useContext} from 'react';
import { ModalContainer,
  UIcon,
  IconContainer,
  StyleLabel,
  MainContentContainer1,
  SubmitContainer,
  StyleButton
 } from './CreateAdminUser';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useSettingModal } from '../../../../hooks/Context';
import { useDispatch } from 'react-redux';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';

interface Payload {
  UserName: string;
  RoleName: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface RoleProps {
  Id: string;
  Name: string;
  NormalizedName: string;
};

interface RoleResponse {
  data: RoleProps[];
};

const AssignRole = (props:any) => {
  const [roleByUserData, setRoleByUserData] = useState<RoleProps[]>([]);

    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const userData  = props.data ? props.data : null;
    const name = userData ? `${userData.FirstName} ${userData.MiddleName ? userData.MiddleName : ''} ${userData.LastName}` : '';
    const [userRole, setUserRole] = useState('');
    const { setShowModal } = useSettingModal();
    const remove = props.remove ? props.remove : false;
    const roleData = props.roleData ? props.roleData : null;
    //const roleByUserData = props.roleByUserData ? props.roleByUserData : null;

    const { showNotification } = useContext(NotificationContext);

    const handleChange = (event: SelectChangeEvent<typeof userRole>) => {
      const {
        target: { value },
      } = event;
      setUserRole(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value : '',
      );
    };

    const getRoleByUserId = async () => {
      return (await (apiCall().post(`Authentication/GetRoleByUserId?userid=${userData?.UserId}`))) as RoleResponse;
    };
  
    const getRoleByUserIdMutation = useMutation(['get-roleById'], getRoleByUserId, {retry: 0});
  
    // const roleError = getRoleByUserIdMutation?.error as AxiosError;
    // const roleErrorMessage = roleError?.message;
  
    const roleHandler = async () => {
        try {
            const data = await getRoleByUserIdMutation.mutateAsync()
            setRoleByUserData(data?.data)
        } catch (error: any){
  
        }
    }
  
    useEffect(() => {
        roleHandler()
    }, [userData])
   
    const assignAdminUserToRole = async (data: Payload) => {
      return await (apiCall().post('Administration/post/AddUserToRole/user', data))
    };

    const assignAdminUserToRoleMutation = useMutation(['post-adminUser-toRole'], assignAdminUserToRole, { retry: 0 });

    const assignAdminUserToRoleHandler = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const payload: Payload = {
        UserName: userData?.Email,
        RoleName: userRole,
      };

      try {
        await assignAdminUserToRoleMutation.mutateAsync(payload, {
          onSuccess: () => {
            showNotification({
              type: 'success',
              message: 'Role successfully assigned to user',
            })
            queryClient.invalidateQueries(['get-admin-users'])
            setShowModal(false);
          }
        })
      }
      catch (error: any) {
        showNotification({
          type: 'error',
          message: error?.response?.data?.Message || error?.Message,
        })
      }
    };

    const removeAdminUserFromRole = async (data: Payload) => {
      return await (apiCall().post('Administration/post/RemoveUserFromRole/user', data))
    };

    const removeAdminUserFromRoleMutation = useMutation(['remove-adminUser-fromRole'], removeAdminUserFromRole, { retry: 0 });

    const removeAdminUserFromRoleHandler = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const payload: Payload = {
        UserName: userData?.Email,
        RoleName: userRole,
      };

      try {
        await removeAdminUserFromRoleMutation.mutateAsync(payload, {
          onSuccess: () => {
            showNotification({
              type: 'success',
              message: 'User successfully removed from role',
            })
            queryClient.invalidateQueries(['get-admin-users'])
            setShowModal(false);
          }
        })
      }
      catch (error: any) {
        showNotification({
          type: 'error',
          message: error?.response?.data?.Message || error?.Message,
        })
      }
    };

    //filter to get roles not yet assigned to a user
    const filteredRole = roleData.filter((data1: any) => {
      return !roleByUserData.some((data2: any) => {
        return data1?.Name === data2?.Name;
      })
    });

    //filter to get roles already assigned to a user 
    const filteredRole2 = roleData.filter((data1: any) => {
      return roleByUserData.some((data2: any) => {
        return data1?.Name === data2?.Name;
      })
    });

    return (
      <ModalContainer>
        <div>
          <div>
            <div>
              <IconContainer><UIcon /></IconContainer>
              <span>{!remove ? 'Assign Role' : 'Remove Role'}</span>
              </div>
            </div>
            <MainContentContainer1 onSubmit={remove ? removeAdminUserFromRoleHandler : assignAdminUserToRoleHandler}>
              <div>
                <span>Admin: </span>
                <span>{name}</span>
              </div>
              <StyleLabel className='full' style={{marginTop: "15px", marginBottom: "30px"}}>
                <span>Role</span>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  //multiple
                  value={userRole}
                  onChange={handleChange}
                  input={<OutlinedInput label="Role" />}
                  renderValue={(selected) => selected}
                  MenuProps={MenuProps}
                >
                  {remove ? 
                    (filteredRole2.length > 0 && filteredRole2?.map((role: any, index: number) => (
                    <MenuItem key={index} value={role?.Name}>
                      <Checkbox checked={userRole.indexOf(role?.Name) > -1} />
                      <ListItemText primary={role?.Name} />
                    </MenuItem>
                  ))) : (
                    filteredRole.length > 0 && filteredRole?.map((role: any, index: number) => (
                      <MenuItem key={index} value={role?.Name}>
                        <Checkbox checked={userRole.indexOf(role?.Name) > -1} />
                        <ListItemText primary={role?.Name} />
                      </MenuItem>
                    ))
                  )}
                </Select>
              </StyleLabel>
              <SubmitContainer>
                <span onClick={() => setShowModal(false)}>Cancel</span>
                {remove ? (
                  <StyleButton 
                    style={{backgroundColor: remove ? '#DD5151' : '#11643C'}} 
                    disabled={removeAdminUserFromRoleMutation.isLoading}
                  >
                    {removeAdminUserFromRoleMutation.isLoading ? 'Removing...' : 'Remove Role'}
                  </StyleButton>
                ) : (
                  <StyleButton 
                    style={{backgroundColor: remove ? '#DD5151' : '#11643C'}} 
                    disabled={assignAdminUserToRoleMutation.isLoading}
                  >
                    {assignAdminUserToRoleMutation.isLoading ? 'Assigning...' : 'Assign Role'}
                  </StyleButton>
                )}
              </SubmitContainer>
            </MainContentContainer1>

        </div>
      </ModalContainer>
    )
  }

export default AssignRole;

